export const ENDPOINTS = {
  metaData: 'core/api/v1/ui-metadata',
  vehicles: 'core/api/v1/vehicles',
  searchVehicles: 'core/api/v1/vehicles/search',
  vehiclesSummary: 'core/api/v1/vehicles/summary',
  getVehicle: (reservationId: string) => `core/api/v1/vehicles/${reservationId}`,
  vehicleConfiguration: (reservationId: string) => `core/api/v1/vehicles/${reservationId}/config`,
  vehicleTeam: (reservationId: string) => `core/api/v1/vehicles/${reservationId}/team`,
  vehicleCustomer: (email: string, reservationId: string) => `core/api/v1/customers/${email}/${reservationId}`,
  vehiclePayment: 'core/api/v1/payments',
  vehicleFilters: 'core/api/v1/filters',
  vehicleFiltersDelete: (id: string) => `core/api/v1/filters/${id}`,
  registrationConfiguration: (reservationId: string) => `core/api/v1/registration/${reservationId}/config`,
  deliveryConfiguration: (reservationId: string) => `core/api/v1/delivery/${reservationId}/config`,
  vehicleOrderInfo: (reservationId: string) => `core/api/v1/vehicles/${reservationId}/order`,
  getActions: 'core/api/v1/actions/items',
  updateActionStatus: 'core/api/v1/actions/item/updateStatus',
  transit: `core/api/v1/transit`,
  production: 'core/api/v1/production',
  lifeCycleSnapshot: 'core/api/v1/lifeCycleSnapshot',
  simulator: 'core/api/v1/simulator',
  case: '/core/api/v1/case',
  productionsStageInfo: 'core/api/v1/productionstageinfo',
  deliveryProgress: '/core/api/v1/lifeCycleSnapshot/lookupMaster/deliveryProgress',
  profile: 'core/api/v1/profile',
  inspect: 'core/api/v1/inspect',
  getPermissions: 'inventory/api/v1/roles/get-user-roles',
  containment: 'core/api/v1/containment',
  // inventoryDetails: `inventory/api/v1/inventory/inventory-details`,
  ofacDetails: `inventory/api/v1/ofac/ofac-details`,
  searchInventoryCustomer: 'inventory/api/v1/inventory/search-customer',
  searchInvCustomerWithoutOrder: 'inventory/api/v1/inventory/search-no-order-customer',
  getAssignments: 'inventory/api/v1/assignment/get-assignment',
  getUnAssignedOrders: 'inventory/api/v1/assignment/get-customer-orders',
  // createAssignment: 'inventory/api/v1/assignment/create-assignment',
  createAssignment: 'inventory/api/v2/assignment/create-assignment',
  requestAssignment: 'inventory/api/v1/assignment/request-assignment',
  cancelAssignment: 'inventory/api/v1/assignment/cancel-assignment',
  // approveAssignment: 'inventory/api/v1/assignment/approve-assignment',
  approveAssignment: 'inventory/api/v2/assignment/approve-assignment',
  retryOnHoldAssignment: 'inventory/api/v2/assignment/buy-now-assignment',
  rejectAssignment: 'inventory/api/v1/assignment/reject-assignment',
  releaseOrCancelOrder: 'inventory/api/v2/inventory/action',
  inventoryDetails: (
    perPage: number,
    page: number,
    sortStatus?: boolean,
    sort?: any,
    grouping?: any,
    groupKeys?: any
  ) => {
    let url = `inventory/api/v1/inventory/inventory-details?perPage=${perPage}&page=${page}`;
    if (sortStatus) {
      url += `&sort=${sort}`;
    }
    if (grouping && groupKeys?.length === 0) {
      url += `&groupBy=${grouping}`;
    }
    if (grouping && groupKeys?.length > 0) {
      groupKeys = groupKeys[0]?.split(' (')[0];
      if (grouping.includes('Date')) {
        const d = new Date(groupKeys);
        /* eslint-disable prefer-template */
        groupKeys = [d.getFullYear(), ('0' + (d.getMonth() + 1)).slice(-2), ('0' + d.getDate()).slice(-2)].join('-');
      }
      const key = `${grouping}:${groupKeys}`;
      url += `&groupByData=${key}`;
    }
    url = url.replace(/inventoryVehicle./gi, 'inventoryVehicle_');
    url = url.replace(/customerVehicle./gi, 'customerVehicle_');
    return url;
  },
  getAllVehicles: (
    perPage: number,
    page: number,
    sortStatus?: boolean,
    sort?: any,
    grouping?: any,
    groupKeys?: any
  ) => {
    /* eslint-disable no-else-return */
    let url = `inventory/api/v1/inventory/get-all-vehicles?perPage=${perPage}&page=${page}`;
    if (sortStatus) {
      url += `&sort=${sort}`;
    }
    if (grouping && groupKeys?.length === 0) {
      url += `&groupBy=${grouping}`;
    }
    if (grouping && groupKeys?.length > 0) {
      const index = groupKeys[0].lastIndexOf('(');
      if (index !== -1) {
        groupKeys = groupKeys[0].substring(0, index).trim();
      } else {
        groupKeys = groupKeys[0].trim();
      }
      if (grouping.includes('Date')) {
        const d = new Date(groupKeys);
        /* eslint-disable prefer-template */
        groupKeys = [d.getFullYear(), ('0' + (d.getMonth() + 1)).slice(-2), ('0' + d.getDate()).slice(-2)].join('-');
      }
      const key = `${grouping}:${groupKeys}`;
      url += `&groupByData=${key}`;
    }
    url = url.replace(/inventoryVehicle./gi, 'inventoryVehicle_');
    url = url.replace(/customerVehicle./gi, 'customerVehicle_');
    url = url.replace(/prevAssgnChange./gi, 'prevAssgnChange_');
    return url;
  },
  getAllChangeHistory: (
    perPage: number,
    page: number,
    sortStatus?: boolean,
    sort?: any,
    grouping?: any,
    groupKeys?: any
  ) => {
    let url = `inventory/api/v1/inventory/get-vehicle-change-history?perPage=${perPage}&page=${page}`;
    if (sortStatus) {
      url += `&sort=${sort}`;
    }
    if (grouping && groupKeys?.length === 0) {
      url += `&groupBy=${grouping}`;
    }
    if (grouping && groupKeys?.length > 0) {
      groupKeys = groupKeys[0]?.split(' (')[0];
      if (grouping.includes('createdAt')) {
        const d = new Date(groupKeys);
        /* eslint-disable prefer-template */
        groupKeys = [d.getFullYear(), ('0' + (d.getMonth() + 1)).slice(-2), ('0' + d.getDate()).slice(-2)].join('-');
      }

      // Email ID grouping
      else if (groupKeys?.includes('.com')) {
        /* eslint-disable no-unsafe-optional-chaining */
        const [one, two] = groupKeys?.split('@');
        groupKeys = encodeURIComponent(one) + '@' + two;
      } else if (groupKeys === 'Bulk') {
        groupKeys = true;
      } else if (groupKeys === 'Single') {
        groupKeys = false;
      } else {
        groupKeys = encodeURIComponent(groupKeys);
      }
      const key = `${grouping}:${groupKeys}`;
      url += `&groupByData=${key}`;
    }
    url = url.replace(/inventoryVehicle./gi, 'inventoryVehicle_');
    url = url.replace(/customerVehicle./gi, 'customerVehicle_');
    url = url.replace(/vehiclDetails./gi, 'vehiclDetails_');
    return url;
  },
  getApprovedOrRejectedAssignments: (
    status: string,
    perPage: number,
    page: number,
    sortStatus?: boolean,
    sort?: any,
    grouping?: any,
    groupKeys?: any
  ) => {
    let url = `inventory/api/v1/assignment/get-assignment?status=${status}&perPage=${perPage}&page=${page}`;
    if (sortStatus) {
      url += `&sort=${sort}`;
    }
    if (grouping && groupKeys?.length === 0) {
      url += `&groupBy=${grouping}`;
    }
    if (grouping && groupKeys?.length > 0) {
      groupKeys = groupKeys[0]?.split(' (')[0];

      // Email ID grouping
      if (groupKeys?.includes('.com')) {
        /* eslint-disable no-unsafe-optional-chaining */
        const [one, two] = groupKeys?.split('@');
        groupKeys = encodeURIComponent(one) + '@' + two;
      } else if (grouping.includes('Date')) {
        const d = new Date(groupKeys);
        /* eslint-disable prefer-template */
        groupKeys = [d.getFullYear(), ('0' + (d.getMonth() + 1)).slice(-2), ('0' + d.getDate()).slice(-2)].join('-');
      } else {
        groupKeys = encodeURIComponent(groupKeys);
      }
      const key = `${grouping}:${groupKeys}`;
      console.log(key);
      url += `&groupByData=${key}`;
    }
    url = url.replace(/inventoryVehicle./gi, 'inventoryVehicle_');
    url = url.replace(/customerVehicle./gi, 'customerVehicle_');

    return url;
  },
  getAssignmenTypes: 'inventory/api/v1/assignment/assignment-types',
  getAssignmenTypesFieldDetails: 'inventory/api/v1/custom-fields/get-field-details',
  updateAssignmentType: 'inventory/api/v1/assignment/update-assignment-type',
  vehicleUpgradeOptions: (batchNumber: string) => `inventory/api/v1/inventory/${batchNumber}/vehicle-upgrade-options`,
  getVehicleFilterValues: (fieldName: string) =>
    `inventory/api/v1/inventory/get-all-vehicles?perPage=50&page=1&filterValues=${fieldName}`,
  getChangeHistoryFilterValues: (fieldName: string) =>
    `inventory/api/v1/inventory/get-vehicle-change-history?perPage=50&page=1&filterValues=${fieldName}`,
  getInventoryFilterValues: (fieldName: string, ignoreValues: string) => {
    let url = `inventory/api/v1/inventory/inventory-details?perPage=50&page=1&filterValues=${fieldName}`;
    if (fieldName === 'titleStatus') {
      url += `&ignoreValues=${ignoreValues}`;
    }
    return url;
  },
  getAssignmentFilterValues: (status: string, fieldName: string) =>
    `inventory/api/v1/assignment/get-assignment?status=${status}&perPage=50&page=1&filterValues=${fieldName}`,
  exportData: (sortStatus?: boolean, sort?: any) => {
    /* eslint-disable no-else-return */
    let url = `inventory/api/v1/inventory/export-data`;
    if (sortStatus) {
      url += `?sort=${sort}`;
    }
    url = url.replace(/inventoryVehicle./gi, 'inventoryVehicle_');
    url = url.replace(/customerVehicle./gi, 'customerVehicle_');
    url = url.replace(/prevAssgnChange./gi, 'prevAssgnChange_');
    return url;
  },
} as const;

export const META_DATA_MODULES = {
  vehicles: 'Vehicles',
  dashboard: 'Dashboard',
  v360Page: 'V360Page',
  homeDashboard: 'HomePage/Dashbord',
};

export const META_DATA_SUB_MODULES = {
  vehiclesGrid: 'Grid',
  vehicleSummary: 'VehicleSummary',
  vehicleDetailsTabs: 'VehicleDetailsTabs',
  customerDetailsTabs: 'CustomerTab',
  vehicleTab: 'VehicleTab',
  registrationTab: 'RegistrationTab',
  deliveryTab: 'DeliveryTab',
  orderTab: 'OrderTab',
  documentTab: 'DocumentTab',
  notification: 'Notification',
  vehicleSummaryDetails: 'VehicleSummaryDetails',
  DMVTab: 'DMVTab',
  KYCTab: 'KYCTab',
  insuranceTab: 'InsuranceTab',
  lucidTeamTab: 'LucidTeamTab',
  transitTab: 'TransitTab',
  payment: 'Payments',
  productionTab: 'ProductionTab',
  pricingPurchaseAgreement: 'PricingPurchaseAgreement',
  LifeCycleSnapShot: 'LifeCycleSnapShot',
  ScheduleDelivery: 'ScheduleDelivery',
  CustomerHandoff: 'CustomerHandoff',
  VehicleRegistration: 'VehicleRegistration',
};

const oktaStorage = window?.localStorage?.getItem?.('okta-token-storage');
const userInfo = oktaStorage ? JSON.parse(oktaStorage)?.idToken?.claims : null;
export const GLOBAL_USER = userInfo?.email ? userInfo?.email.split('@')?.[0] : 'rohitsethi';
// export const GLOBAL_USER = 'rohitSethi';

const path = (route: string) => `/v360-app/${route}`;

export const PATHS = {
  dashboard: path(''),
  inventory: path('inventory'),
  vehicles: path('vehicles'),
  vahicle: (id: string) => path(`vehicles/${id}`),
  help: path('help'),
  assignment: path('assignment'),
} as const;

export const notificationsRange = ['All', 'Today', 'Last 3 days', 'This week'] as const;

export const stages = ['Reserved', 'Ordered', 'Production', 'Transit', 'Inspection', 'Delivery', 'Ownership'] as const;

export const FEEDBACK_URL = 'https://app.smartsheet.com/b/form/ac41af1d5ee54f76b31f82210f24d950' as const;
export const deepLink = 'https://lucid-motors--lucidstage.lightning.force.com/';
export const requestUrl = 'https://lucidmotors.atlassian.net/servicedesk/customer/portal/2/group/19/create/568';

export const timeZone = new Date().getTimezoneOffset();

export const countryMapping: any = {
  US: 'en-us',
  CA: 'en-ca',
  DE: 'de-de',
  NL: 'nl-nl',
  CH: 'de-ch',
  NO: 'nb-no',
  KSA: 'ar-sa',
  SA: 'ar-sa',
  UAE: 'ar-ae',
  AE: 'ar-ae',
  BE: 'fr-be',
};

export const countiesMapping = [
  { name: 'Canada', localeCode: 'en-ca', locale: 'en' },
  { name: 'Germany', localeCode: 'de-de', locale: 'de' },
  { name: 'Netherlands', localeCode: 'nl-nl', locale: 'nl' },
  { name: 'Norway', localeCode: 'nb-no', locale: 'nb' },
  { name: 'Switzerland', localeCode: 'de-ch', locale: 'ch' },
  { name: 'United States', localeCode: 'en-us', locale: 'en' },
  { name: 'Saudi Arabia', localeCode: 'ar-sa', locale: 'ar' },
  { name: 'United Arab Emirates', localeCode: 'ar-ae', locale: 'ar' },
  { name: 'Belgium', localeCode: 'fr-be', locale: 'fr' },
];
